module.exports = __webpack_public_path__ + "static/media/header-shape.4a42a85b.svg";